import React, { useState } from "react"
import { Col, Row } from "react-bootstrap";
import { ReactComponent as ImageCaretRight } from '../../../images/caret-right-fill.svg';
import FptProgrammModal from "../../controls/FptProgrammModal";

const ProgrammRaster2020 = (props) => {

    const [programmData, setProgrammData] = useState({
        tag: undefined,
        datum: undefined,
        wochentag: undefined,
        xmlFile: undefined,
        idFpt: undefined
    });

    const [showModal, setShowModal] = useState(false);

    //#region FormEvents

    const bttnDetailTag1Click = () => {
        setProgrammData({
            tag: 'tag1',
            datum: '04.02.2020',
            wochentag: 'Dienstag',
            xmlFile: 'fpt031_tag1.xml',
            idFpt: 'fpt031'
        });
        setShowModal(true);
    }

    const bttnDetailTag2Click = () => {
        setProgrammData({
            tag: 'tag2',
            datum: '05.02.2023',
            wochentag: 'Mittwoch',
            xmlFile: 'fpt031_tag2.xml',
            idFpt: 'fpt031'
        });

        setShowModal(true);
    }

    //#endregion

    return (
        <React.Fragment>

            <Row className='pb-4 pb-lg-0'>
                <Col xs={12} md={6} className='pb-4'>
                    <div className="d-flex flex-column programm-wrapper" onClick={bttnDetailTag1Click}>
                        <div className="programm-white shadow-sm">
                            <strong>Dienstag</strong> 04.02.2020
                        </div>
                        <div className="programm-orange shadow-sm">
                            Sensorik<br /><br />
                            Prozesstechnik<br /><br />
                            Messtechnik<br />
                            <br />
                        </div>
                        <div className="programm-black shadow-sm">
                            Meet-the-Press-Abend
                        </div>
                        <div className="programm-link">
                            <ImageCaretRight className="ProgrammDetailsButtonCaret" /> Details anzeigen
                        </div>
                    </div>
                </Col>
                <Col xs={12} md={6}>
                    <div className="d-flex flex-column programm-wrapper" onClick={bttnDetailTag2Click}>
                        <div className="programm-white shadow-sm">
                            <strong>Mittwoch</strong> 05.02.2020
                        </div>
                        <div className="programm-orange shadow-sm">
                            Smart Factory<br /><br />
                            Motion &amp; Robotik<br /><br />
                            Netzwerktechnik
                            <br />
                            <br />
                        </div>
                        <div className="programm-link">
                            <ImageCaretRight className="ProgrammDetailsButtonCaret" /> Details anzeigen
                        </div>
                    </div>
                </Col>
            </Row>

            {showModal &&
                <FptProgrammModal onClose={() => setShowModal(false)} data={programmData} />
            }

        </React.Fragment>
    )

}
export default ProgrammRaster2020;
